import "./style.scss";

import AlertTriangle from "assets/img/svg/alertTriangle";
import Basket from "assets/img/svg/basket";
import basketCircle from "assets/img/svg/basketCircle";
import Plus from "assets/img/svg/plus";
import ModalBox from "components/Modal";
import ButtonBase from "components/shared/ButtonBase";
import DeleteModal from "components/shared/DeleteModal";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { fetchPeriods } from "store/periodStore";
import { deleteLocation, fetchLocations } from "store/stockStore";
import type { AppDispatch } from "store/store";
import { useAppSelector } from "store/store";

interface IStockSettings {
    hasEdited: () => void;
    onLocationUpdate: (e: string[], type: string) => void;
}

const StockSettings = (props: IStockSettings) => {
    const { hasEdited, onLocationUpdate } = props;
    const [t] = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const [locationList, setLocationList] = useState<any[]>([]);
    const { activePeriod } = useAppSelector((state) => state.period);
    const { locations } = useAppSelector((state) => state.stock);

    const [showModal, setShowModal] = useState<boolean>(false);
    const [stockToDelete, setStockToDelete] = useState<{
        index: number;
        id: number;
        name: string;
    } | null>(null);

    const handleAddLocation = () => {
        setLocationList((location: any[]) => {
            const newLocation = [...location.map((item: any) => item), { id: null, name: "" }];
            onLocationUpdate(
                newLocation.filter((item: any) => item.id == undefined || item.id == null),
                "post",
            );
            return newLocation;
        });
        hasEdited();
    };

    const handleLocationChange = (value: string, i: number, id: number) => {
        const newArray: any = locationList.slice();
        newArray[i] = { ...newArray[i], name: value, modified: true };
        setLocationList(newArray);
        hasEdited();
        if (id == undefined || id == null)
            onLocationUpdate(
                newArray.filter((item: any) => item.id == undefined || item.id == null),
                "post",
            );
        else
            onLocationUpdate(
                newArray.map((item: any) => ({ ...item })),
                "put",
            );
    };

    const handleRemoveLocation = (i: number, id: number) => {
        setLocationList((location) => {
            const newLocation = location.filter((loc: any, pos: number) => pos != i);
            onLocationUpdate(newLocation, "delete");
            return newLocation;
        });
        if (id != undefined) {
            dispatch(deleteLocation(id)).then((resp) => {
                if (resp.meta.requestStatus === "fulfilled") {
                    if (activePeriod) dispatch(fetchLocations(activePeriod));
                    setShowModal(false);
                    setStockToDelete(null);
                }
            });
            return;
        }
        // hasEdited()
    };

    useEffect(() => {
        !activePeriod && dispatch(fetchPeriods());
        if (activePeriod) dispatch(fetchLocations(activePeriod));
    }, [activePeriod, dispatch]);

    useEffect(() => {
        setLocationList(locations || []);
    }, [locations]);

    const handleDeleteLocation = async () => {
        !!stockToDelete && handleRemoveLocation(stockToDelete.index, stockToDelete.id);
    };

    return (
        <div className="info-block stock-setting">
            <div className="info-block-head">
                <div className="info-block-head-name">{t("Stock.StockLocation")}</div>
                <div className="add-location" onClick={handleAddLocation}>
                    <Plus fill="#3C78F0" />
                    {t("Stock.AddLocation")}
                </div>
            </div>
            <div className="info-block-list">
                {locationList.length > 0 &&
                    locationList.map((item: any, i: number) => (
                        <div className="info-block-list-element" key={i}>
                            <StyledTextField
                                size="small"
                                value={item.name}
                                onChange={(e) => handleLocationChange(e.target.value, i, item.id)}
                                sx={{ width: "90%" }}
                            ></StyledTextField>
                            {locationList.length > 0 && (
                                <div className="delete-icon">
                                    <Basket
                                        onClick={() => {
                                            setStockToDelete({
                                                index: i,
                                                id: item.id,
                                                name: item.name,
                                            });
                                            setShowModal(true);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                {/* <div className="info-block-list-element show-stock-movement">
                    <div className="label">
                        {t("Stock.ShowMovement")}
                    </div>
                    <div className="switch">
                        <IosSwitch checked={!!stockMovement} onChange={onShowStockMovements} />
                    </div>
                </div> */}
            </div>
            <DeleteModal
                open={showModal}
                onClose={() => {
                    setShowModal(false);
                    setStockToDelete(null);
                }}
                onDelete={handleDeleteLocation}
                elementTitle={t("Stock.RemoveLocation", { name: stockToDelete?.name })}
            />
        </div>
    );
};

export default StockSettings;
